<template>
  <section style="width: 100%">
    <v-btn color="primary" dark class="my-3" @click.stop="editItems()" v-if="isWriteAvailable">Add Predefined Activity</v-btn>

    <v-data-table
      class="elevation-1"
      :headers="header"
      :items="predefinedActivityClone"
      :pagination.sync="pagination"
      :total-items="totalItemsInTable"
      :loading="loading"
      :disable-initial-sort="true"
    >
      <template slot="items" slot-scope="props">
        <td class="py-4">
          <v-avatar><img :src="(props.item.imageUrl) || 'http://via.placeholder.com/350x200.jpg'" alt="no image">
          </v-avatar>
        </td>
        <td>{{ props.item.title }}</td>
        <td class="pt-2" v-html="props.item.description"></td>
        <td>
          <div v-for="(value, index) in activityDisplayLocation" :key="index">
            <v-checkbox
              small
              :label="value"
              v-model="props.item.activityDisplayLocation"
              :value="value"
              disabled
              class="my-0"
            />
          </div>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="lime"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click.stop="editItems(props.item)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="error"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click.stop="deletePackage(props.item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="dialogSettings.open" max-width="500px">
      <v-card>
        <v-card-media
          v-if="editedItem.imageUrl"
          :src="editedItem.imageUrl"
          height="200px"
        />
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs7>
                <content-field
                  label="Title"
                  v-model="editedItem.title"
                  @input="$v.editedItem.title.$touch"
                  @blur="$v.editedItem.title.$touch"
                  :error="$v.editedItem.title"
                />
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <content-editor
                    label="Description"
                    v-model="editedItem.description"
                    @input="$v.editedItem.description.$touch"
                    @blur="$v.editedItem.description.$touch"
                    :error="$v.editedItem.description"
                  />
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12 d-flex>
                    <p class="checkbox-labels">Display In</p>
                  </v-flex>
                  <v-flex xs12 d-flex>
                    <div v-for="(value, index) in activityDisplayLocation" :key="index">
                      <v-checkbox
                        small
                        :label="value"
                        v-model="editedItem.activityDisplayLocation"
                        :value="value"
                        :error="$v.editedItem.activityDisplayLocation.$error"
                        class="my-0"
                      />
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12 d-flex>
                    <p class="checkbox-labels">Related activities</p>
                  </v-flex>
                  <v-flex xs12 d-flex>
                    <div v-for="(activity, index) in activitiesList" :key="`activity-${index}`">
                      <v-checkbox
                        small
                        :label="activity.label"
                        v-model="editedItem.activity"
                        :value="activity.value"
                        class="my-0"
                      />
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <small v-if="dialogSettings.showRequiredMessage">*indicates required field</small>
              <v-flex xs12>
                <v-btn color="success" @click="modalGallery=!modalGallery">Choose Image</v-btn>
                <v-btn
                  :disabled="!editedItem.imageUrl"
                  color="success"
                  @click="editedItem.imageUrl = ''"
                >
                  Remove Image
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" flat="flat" @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat="flat" @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalGallery">
      <galleries-list :modalView="true" @pickedImage="setImage"/>
    </v-dialog>
  </section>
</template>


<script>
  // Vuex
  import { mapActions, mapGetters } from 'vuex'

  // Components
  import GalleriesList from '@/components/pages/Gallery/GalleriesList'

  // Libs, utils, modules
  import mixins from '@/utils/mixins'
  import { clone, equals, pathOr } from 'ramda'
  import debounce from 'lodash.debounce'
  import { timeSettings } from '@/modules/settings/'
  import { required } from 'vuelidate/lib/validators'
  import { activityDisplayLocation } from '@/modules/settings/'

  export default {
    name: 'Predefined',
    mixins: [mixins.isWriteAvailable],
    components: { GalleriesList },
    data () {
      return {
        activitiesList: [
          {
            label: 'Blitz',
            value: 'Blitz',
          },
          {
            label: 'Listing',
            value: 'Listing',
          },
          {
            label: 'Featured Attendee',
            value: 'FeaturedAttendee',
          }
        ],
        activityDisplayLocation,
        predefinedActivityClone: [],
        loading: true,
        dialogSettings: {
          open: false,
          index: -1
        },
        modalGallery: false,
        header: [
          { text: 'Image', sortable: false, value: 'imageUrl', width: 100 },
          { text: 'Title', sortable: false, value: 'title', width: 400 },
          { text: 'Description', sortable: false, value: 'description' },
          { text: 'Activity Display Location', sortable: false, value: 'activityDisplayLocation' },
          { text: 'Edit', sortable: false, align: 'center', width: 100 },
          { text: 'Delete', sortable: false, align: 'center', width: 100 }
        ],
        pagination: {
          rowsPerPage: 10
        },
        editedItem: {
          id: "",
          title: "",
          description: "",
          imageUrl: "",
          activityDisplayLocation: activityDisplayLocation,
          activity: []
        },
        defaultItem: {
          id: "",
          title: "",
          description: "",
          imageUrl: "",
          activityDisplayLocation: activityDisplayLocation,
          activity: []
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters([
        'predefinedActivity',
        'totalPredefinedActivityItems',
        'totalPredefinedActivityPages'
      ]),
      formTitle () {
        return this.dialogSettings.index === -1 ? 'New Item' : 'Edit Item'
      },
      totalItemsInTable () {
        return this.totalPredefinedActivityItems || (this.totalPredefinedActivityPages * this.pagination.rowsPerPage)
      }
    },
    watch: {
      "dialogSettings.open" (val) {
        val || this.close()
      },
      pagination: {
        handler () {
          this.getPackages()
        },
        deep: true
      },
    },
    methods: {
      ...mapActions([
        'getPredefinedActivity',
        'addPredefinedActivity',
        'editPredefinedActivity',
        'deletePredefinedActivity',
        'showResultSuccessMessage',
        'showResultErrorMessage'
      ]),
      editItems (item) {
        if (item) {
          this.dialogSettings.index = this.predefinedActivityClone.indexOf(item)
          this.editedItem = clone(item)
          this.editedItem.activity = this.editedItem.activity.split(', ')
        }
        this.dialogSettings.open = true
      },
      setImage (item) {
        this.editedItem.imageUrl = item.imagesUrls.originalImageUrl
        this.modalGallery = false
      },
      close () {
        this.$v.editedItem.$reset()
        this.editedItem = clone(this.defaultItem)
        this.dialogSettings.showRequiredMessage = false
        this.dialogSettings.index = -1
        this.dialogSettings.open = false
      },
      save () {
        if (this.$v.editedItem.$invalid) {
          this.$v.editedItem.$touch()
          return false
        }
        this.editedItem.activityDisplayLocation = this.editedItem.activityDisplayLocation.join(', ')
        this.editedItem.activity = this.editedItem.activity.join(', ')
        const item = clone(this.editedItem)
        if (this.dialogSettings.index > -1) {
          this.editPackage(item)
        } else {
          this.addPackage(item)
        }
      },
      preparePackagesGetParams (pagination = this.pagination, totalItems = this.totalPredefinedActivityItems) {
        const { page, rowsPerPage } = pagination
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const itemsOnPage = equals(rowsPerPage, -1) ? totalItems : rowsPerPage
        return {
          page: pageCheck,
          itemsOnPage
        }
      },
      getPackages: debounce(async function () {
        this.loading = true
        try {
          const getParams = this.preparePackagesGetParams()
          await this.getPredefinedActivity(getParams)
          this.predefinedActivityClone = clone(this.predefinedActivity)
          this.predefinedActivityClone.forEach((key, index) => {
            if (!!this.predefinedActivityClone[index].activityDisplayLocation) this.predefinedActivityClone[index].activityDisplayLocation = this.predefinedActivityClone[index].activityDisplayLocation.split(', ')
            else this.predefinedActivityClone[index].activityDisplayLocation = []
          })
        } catch (err) {
          this.showResultErrorMessage(err.message)
        } finally {
          this.loading = false
        }
      }, timeSettings.delayTime),
      async addPackage (item) {
        try {
          await this.addPredefinedActivity(item)
          await this.getPackages()
          this.showResultSuccessMessage('Activity added successful')
          this.close()
        } catch (err) {
          this.showResultErrorMessage(err.message)
        }
      },
      async editPackage (item) {
        try {
          await this.editPredefinedActivity(item)
          await this.getPackages()
          this.showResultSuccessMessage('Activity edit successful')
          this.close()
        } catch (err) {
          this.showResultErrorMessage(err.message)
        }
      },
      async deletePackage (item) {
        try {
          await this.deletePredefinedActivity(item.id)
          await this.getPackages()
          this.showResultSuccessMessage('Activity delete successful')
        } catch (err) {
          let errMessage = pathOr('', ['response', 'data', 'ValidationFailures'], err)
          errMessage = errMessage ? errMessage.map(el => el.errorMessage).join('\n') : err.message
          this.showResultErrorMessage(errMessage)
        }
      }
    },
    async beforeMount () {
      await this.getPackages()
    },
    validations () {
      return {
        editedItem: {
          title: { required },
          description: { required },
          activityDisplayLocation: { required }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.checkbox-labels {
  font-size: 16px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Packages/predefined.vue